import { colorAttentionBlue50, colorFunctionalGray10, colorFunctionalGray50, colorMiscGray90, spacingXs } from "@rhumbix/rmbx_design_system_web"
import { css } from "styled-components"

export const zIndex = {
    SideRail: 5,
    Tooltip: 19,
}

// Just in case you need just the transition specs for the glowy blue border.
export const activeInputTransitionStyles = css`
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
`

// Used to style a border provided by a container element that wraps an input element.
// An example of this is AutocompleteInput.
export const activeInnerInputStyles = css`
    border-color: ${colorAttentionBlue50};
    box-shadow: 0 0 2px 1.5px color-mix(in srgb, ${colorAttentionBlue50} 30%, transparent);
`

// Style an interactable form element like an input or select field with a glowy blue border.
export const activeInputStyles = css`
    ${activeInputTransitionStyles}

    &:not(:disabled) {
        &:focus,
        &:active {
            ${activeInnerInputStyles}
            outline: none;
        }
    }
`

// Use within ::after{ } pseudo-element to add a horizontal separator. Parent should have 'position: relative;'
export const afterHorizontalSeparatorStyles = css`
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    height: 1px;
    background-color: ${colorFunctionalGray50};
`

// Common re-overrides of global styles for form inputs, particularly in the SideRail.
export const commonFormInputStyles = css`
    /* Regular text input fields in the SideRail form */
    .standard-input {
        ${activeInputStyles}
    }

    /* AutocompleteInput text field */
    .autocomplete-input-container {
        border-color: ${colorFunctionalGray50};

        &:focus-within {
            ${activeInnerInputStyles}
        }
    }

    /* Target the react-select (SelectorWrapper) input field */
    .selector-container {
        > div > div[class*="-control"] {
            border-color: ${colorFunctionalGray50};
            min-height: 40px;
            padding-left: ${spacingXs};
            ${activeInputTransitionStyles}

            div[class*="-singleValue"] {
                color: ${colorMiscGray90};
                font-weight: 400;
            }
        }
        /* Blue glow border when focused/active */
        &:focus-within {
            > div > div[class*="-control"] {
                ${activeInnerInputStyles}
            }
        }
        /* Gray background for SelectorWrapper when disabled */
        &:has(input:disabled) {
            background-color: ${colorFunctionalGray10};
        }
    }
`
